function addMessage(message, setMessages, clear = false) {
    if (clear === true) {
        setMessages([]);
        return;
    }

    // message obyekt bo‘lib keladi (masalan {owner, content})
    setMessages((prevMessages) => [...prevMessages, message]);

    // auto scroll
    let chat_area_main = document.querySelector('.chat-area-main');
    setTimeout(() => {
        if (chat_area_main) {
            chat_area_main.scrollTop = chat_area_main.scrollHeight;
        }
    }, 100);
}

export default addMessage;
